import { Component, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { HttpFunctionResult } from '../../../_interfaces/HttpFunctionResult';
import { AddressBase } from '../../../_interfaces/address';
import { ContactPerson } from '../../../_interfaces/ContactPerson';
import { EditArt } from '../../../_interfaces/EditArt';
import { TicketBase } from '../../../_interfaces/ticket';
import { DarkmodeService } from '../../../_provider/darkmode.service';
import { FeedbackService, MsgType } from '../../../_provider/feedback.service';
import { TicketEmployee } from '../../../_provider/tickets/ticket.service';
import { TransferService } from '../../../_provider/transfer.service';
import { KundenPopoverPage } from '../../popover/kunden-popover/kunden-popover.page';
import { TicketArtSelectPage } from '../../ticket-more/ticket-detail-allgemein/ticket-art-select/ticket-art-select.page';
import { TicketEditService } from 'src/app/_provider/ticket-edit.service';
import { AuthService, ROLE } from 'src/app/_provider/auth.service';
import { TicketServiceBase } from 'src/app/_provider/tickets/ticketBase.service';
import { TicketCustomer } from 'src/app/_provider/tickets/ticketCustumer.service';
import { TicketDetailWorkersComponent } from '../../ticket-more/ticket-detail-workers/ticket-detail-workers.component';
import { WorkerAddingTicketService } from '../../ticket-more/ticket-detail-workers/worker-services/worker-adding-ticket.service';
import { SaveService } from 'src/app/_provider/save.service';
import { WorkstepBase } from 'src/app/_interfaces/workstep';
import { TaskTemplateBase, TaskTemplateItem, TaskTemplateOverviewPage } from 'src/app/_pages/new-settings/ticket-settings/task-template-overview/task-template-overview.page';
import { Task } from 'src/app/_interfaces/Task';
import { GeneralService } from 'src/app/_provider/general.service';
import { CrmDetailPagePage } from 'src/app/_pages/crm-detail-page/crm-detail-page.page';
export interface NewTicket{
  art?: number,
  address: number,
  description: string,
  toCalculate: number,
  status?: number
  customerDescription?: string
  priority?: string
}

@Component({
  selector: 'app-add-ticket',
  templateUrl: './add-ticket.page.html',
  styleUrls: ['./add-ticket.page.scss'],
})
export class AddTicketPage implements OnInit {

  @Output() close: EventEmitter<any> = new EventEmitter<any>()
  private enterOk: boolean = true
  
  //für neues Ticket in Board-Übersicht
  public status: number = 1

  @HostListener("window:keydown.enter")
  async enterPressed(){
    if(!this.enterOk) return
    if(this.descriptionText && this.kunde && this.selectedArt) await this.closePopup()
  }

  @ViewChild("art", {static: true}) artElement: ElementRef
  @ViewChild("description", {static: true}) descElement: ElementRef
  @ViewChild("contactperson", {static: true}) contactpersonElement: ElementRef
  @ViewChild("address", {static: true}) addressElement: ElementRef

  // @HostListener("window:keyup.enter")
  // enterPressed(){
  //   if(!this.descriptionText || !this.kunde || !this.selectedArt) return
  //   this.closePopup()
  // }

  public descriptionText: string = ""
  public ansprechpartner: ContactPerson
  public kunde: AddressBase
  public selectedArt: EditArt
  public customerDescription: string = ""
  public priority: string = "Mittel"

  public isDarkmode: boolean

  private ticketSrv: TicketServiceBase

  public selectedTaskTemplate?: TaskTemplateBase

  constructor(
    private modalCtrl: ModalController,
    private transfer: TransferService,
    private feedback: FeedbackService,
    private ticketSrvEmployee: TicketEmployee.TicketService,
    private ticketSrvCustomer: TicketCustomer.TicketService,
    private saveSrv: SaveService.Ticket,
    public darkmode: DarkmodeService,
    public workerAddingTicket: WorkerAddingTicketService,
    private ticketEditSrv: TicketEditService,
    public authSrv: AuthService,
    public generalSrv: GeneralService
  ) {

    if(this.authSrv.role == ROLE.employee) this.ticketSrv = this.ticketSrvEmployee
    else{
      this.ticketSrv = this.ticketSrvCustomer
      this.kunde = (this.ticketSrv as TicketCustomer.TicketService).currentAddress
    }
    this.workerAddingTicket.selectedGroups = []
    this.workerAddingTicket.selectedObserverEmployees = []
    this.workerAddingTicket.selectedObserverGroups= []
    this.workerAddingTicket.selectedEmployees = [+this.authSrv.getUser().id]
  }

  ngOnInit() {
    // setTimeout(() => {
    //   this.descElement.nativeElement.focus()
    // }, 500);
  }

  ionViewDidEnter(){
    setTimeout(() => {
      this.descElement.nativeElement.focus()
    }, 100);
  }

  ngOnDestroy(){
  }

  public get fullContactName(): string{
    if(!this.ansprechpartner) return ""
    return `${this.ansprechpartner.firstName} ${this.ansprechpartner.lastName}`
  }

  public async closePopup(){

    //Mitarbeiter
    //Sonst Kunde
    let toCaclulateId: number = 0
    if(this.authSrv.role == ROLE.employee){
      if(!this.descriptionText || !this.kunde || !this.selectedArt){
        await this.feedback.showError("Bitte füllen Sie alle Felder aus.")
        return
      }

      //Zu berechnen anhand der Ticketart festlegen
      if(this.selectedArt.toCalculate >= 0){
        const toCalculate: EditArt = this.ticketEditSrv.toCalculateList.find(tc => tc.id == this.selectedArt.toCalculate)
        if(!toCalculate) return
        toCaclulateId = toCalculate.id
      }
    }else{
      if(!this.descriptionText || !this.customerDescription){
        await this.feedback.showError("Bitte füllen Sie alle Felder aus.")
        return
      }
    }
    
    await this.feedback.updateLoading("Ticket anlegen...")
    const newTicket: NewTicket = {
      art: this.selectedArt?.id,
      address: this.kunde.managerId,
      description: this.descriptionText,
      toCalculate: toCaclulateId,
      customerDescription: this.customerDescription.replace(/\n/g, "<br/>"),
      status: this.status,
      priority: this.priority
    }
    const result: HttpFunctionResult<TicketBase> = await this.ticketSrv.createNewTicket(newTicket)

    if(result.success){

      //Zuweisungen wenn man Mitarbeiter ist
      if(this.authSrv.role == ROLE.employee){

        //Mitarbeiter zuordnen
        const workstepResult: HttpFunctionResult<WorkstepBase[]> = await this.ticketSrv.getWorksteps(result.data.id);
        if(!workstepResult.success) return
        await Promise.all([
          this.workerAddingTicket.selectedEmployees.map(e=>this.saveSrv.saveOrDeleteEditor(e, true, result.data.id, workstepResult.data[0].id, false)),
          this.workerAddingTicket.selectedGroups.map(e=>this.saveSrv.saveOrDeleteGroupe(e, true, result.data.id, workstepResult.data[0].id, false)),
          this.workerAddingTicket.selectedObserverEmployees.map(e=>this.saveSrv.saveOrDeleteEditor(e, true, result.data.id, workstepResult.data[0].id, true)),
          this.workerAddingTicket.selectedObserverGroups.map(e=>this.saveSrv.saveOrDeleteGroupe(e, true, result.data.id, workstepResult.data[0].id, true)),
        ])

        //Task-Template zuweisen in Arbeitsschritt
        if(this.selectedTaskTemplate){
          const tasksResult: HttpFunctionResult<TaskTemplateItem[]> = await (this.ticketSrv as TicketEmployee.TicketService).getTasksByTemplate(this.selectedTaskTemplate.id)

          if(tasksResult.success)
            await Promise.all(tasksResult.data.map(t =>{
              return (this.ticketSrv as TicketEmployee.TicketService).addTask({
                description: t.description,
                orderNumber: t.sort
              }, workstepResult.data[0].id )
            }))
        }
      }


      result.data.lastUpdate = new Date()
      result.data.art = this.selectedArt.id
      await this.feedback.hideKeyboardOnIOS()

      this.modalCtrl.dismiss(result.data)
    }else{
      if(result.data) if(result.data.number == "DEMO") {
        await this.feedback.hideLoading()
        await this.feedback.showMsg(MsgType.Info, "In der Demo-Version kann leider kein neues Ticket angelegt werden. Sie können jedoch in den existierenden Tickets alles ausprobieren.🥸")
        await this.feedback.hideKeyboardOnIOS()
        await this.modalCtrl.dismiss(null)
      }
    }
    await this.feedback.hideLoading()
  }

  async showKundePopover(){
      if(this.authSrv.role == ROLE.customer) return
      await this.feedback.hideKeyboardOnIOS()
      const modal = await this.modalCtrl.create({
        component: KundenPopoverPage,
        componentProps: {type: "modal"}
      })
      modal.onWillDismiss().then(()=>{
        const value: AddressBase = this.transfer.getVALUE() as AddressBase
        if(value){
          this.kunde = Object.assign({},value)
          this.ansprechpartner = null
          this.transfer.setVALUE(null)
          if(!this.selectedArt)
          // this.artElement.nativeElement.focus()
          if(this.selectedArt == null) 
            this.showArtPopover()
        }
      })
      await modal.present()
    // }
  }
  public async showArtPopover(){

    await this.feedback.openModal(TicketArtSelectPage, {type: "modal"}, (result: HttpFunctionResult<EditArt>)=>{
      if(!result.success) return
      this.selectedArt = result.data
    })
  }

  public async closeModal(){
    await this.feedback.hideKeyboardOnIOS()
    await this.modalCtrl.dismiss(null)
  }

  public checkDescriptionEnter(event: KeyboardEvent){
    if(event.key == "Enter" || event.key == "Tab") this.showKundePopover()
  }

  public async addEmployee(){
    this.enterOk = false
    this.workerAddingTicket.isExisting = false
    await this.feedback.openModal(TicketDetailWorkersComponent, {}, ()=>this.enterOk = true)
    this.workerAddingTicket.isExisting = true
  }

  public async addTaskTemplate(){
    this.enterOk = false
    await this.feedback.openModal(TaskTemplateOverviewPage, {toSelect: true}, (result: HttpFunctionResult<TaskTemplateBase>)=>{
      this.enterOk = true
      if(result.success) this.selectedTaskTemplate = result.data
    })
  }

  public async openAddressDetails(address: AddressBase){
      this.generalSrv.setActiveCrm(address)
      await this.feedback.openModal<any>(CrmDetailPagePage, {isModal: true})
    }
}
